module.exports = __webpack_public_path__ + "static/media/johannesgergin.fe0652d0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/johannesgergin.webp
// module id = 620
// module chunks = 0